<template>
    <div class="HelpModal">
        <v-btn icon small :color="buttonColor ? buttonColor : 'primary'" @click="toggleHelpModal(true)">
            <v-icon small>fas fa-question-circle</v-icon>
        </v-btn>
        <v-dialog v-model="showModal"
                  width="500"
        >
            <v-card>
                <v-card-title>
                    <span class="HelpModal__title" v-if="title">{{title}}</span>
                    <v-spacer/>
                    <v-btn icon small @click="toggleHelpModal(false)">
                        <v-icon small>fas fa-times-circle</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="HelpModal__wysiwyg" v-html="text"></v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
        },

        title: {
            type: String,
        },

        buttonColor: {
            type: String,
        }
    },

    data() {
        return {
            showModal: false,
        };
    },

    methods: {
        toggleHelpModal(value) {
            this.showModal = value;
        },
    }
};
</script>
<style lang="scss">
.HelpModal {

}

.HelpModal__wysiwyg {
    iframe {
        width: 100% !important;

        @media (min-width: 500px) {
            min-height: 281px !important;
        }
    }

    ul, ol {
        margin-bottom: 16px !important;
        li {
            margin-bottom: 6px;

            &:last-of-type {
                margin-bottom: 0 !important;
            }
        }
    }
}
</style>
